import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "onlyPageIndicators", "pageIndicatorIcon", "show", "disableIndicatorsOnLimit", "directionIndicatorIcons"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useContext } from 'react';
import { Pagination as SemanticPagination } from 'semantic-ui-react';
import _get from 'lodash/get';
import { DirectionIndicatorIconsPropType } from './PaginationIndicators.types';
import { getPaginationIndicatorProps } from './PaginationIndicators.utils';
import { GoogleAnalytics } from '../../../../../../services/analytics';
import { classNames } from '../../../../../../utils/classname';
import { EVENT_ACTIONS } from '../../../../../analytics/components/Event/Event.constants';
import useSemanticUiProps from '../../../../hooks/use-semantic-ui-props';
import { PaginationContext } from '../../contexts/pagination';
import './PaginationIndicators.css';
var defaultProps = {
  className: '',
  onlyPageIndicators: false,
  pageIndicatorIcon: '',
  show: true,
  disableIndicatorsOnLimit: false,
  directionIndicatorIcons: {}
};
export default function PaginationIndicators(_ref) {
  var className = _ref.className,
    onlyPageIndicators = _ref.onlyPageIndicators,
    pageIndicatorIcon = _ref.pageIndicatorIcon,
    show = _ref.show,
    disableIndicatorsOnLimit = _ref.disableIndicatorsOnLimit,
    directionIndicatorIcons = _ref.directionIndicatorIcons,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useSemanticUiProps = useSemanticUiProps(),
    getMenuProps = _useSemanticUiProps.getMenuProps;
  var _useContext = useContext(PaginationContext),
    pagination = _useContext.pagination,
    event = _useContext.event;
  var activePage = pagination.activePage,
    totalPages = pagination.totalPages,
    onPageChange = pagination.onPageChange;
  var paginationIndicatorProps = getPaginationIndicatorProps({
    onlyPageIndicators: onlyPageIndicators,
    pageIndicatorIcon: pageIndicatorIcon,
    activePage: activePage,
    totalPages: totalPages,
    disableIndicatorsOnLimit: disableIndicatorsOnLimit,
    directionIndicatorIcons: directionIndicatorIcons
  });
  if (totalPages <= 1 || !show) {
    return null;
  }
  var finalClassName = classNames(_defineProperty({
    'pagination-indicators': true
  }, className, className));
  function handlePageChange(e, data) {
    var category = _get(event, 'category');
    var action = EVENT_ACTIONS.PAGINATION_INDICATOR_EVENT_ACTION;
    onPageChange(e, data);
    GoogleAnalytics.event(category, action, {
      label: data.activePage
    });
  }
  return /*#__PURE__*/React.createElement(SemanticPagination, _extends({
    activePage: activePage,
    onPageChange: handlePageChange,
    totalPages: totalPages,
    className: finalClassName
  }, getMenuProps(_objectSpread({}, rest)), paginationIndicatorProps));
}
PaginationIndicators.defaultProps = defaultProps;